var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m89.139.029h-5.47c-2.025 0-3.653.734-4.885 2.2-1.098 1.358-1.646 2.991-1.646 4.9v11.19h3.933v-11.339c0-2.03.878-3.045 2.635-3.045h4.08v10.438h-3.971v3.945h7.867v-15.519c0-1.847-.848-2.77-2.543-2.77m-78.542 3.907h-6.495v10.438h6.495zm4.043 14.382h-12.111c-.89 0-1.513-.168-1.866-.504-.354-.337-.53-.981-.53-1.936v-15.85h11.817c1.792 0 2.689.9 2.689 2.697v15.593z",
  fill: "#003a70"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.427.029h3.97v9.109h-3.97zm21.081 18.289h-3.97v-14.382h-6.421v14.382h-3.934v-15.593c0-1.797.915-2.696 2.744-2.696h8.946c1.757 0 2.635.923 2.635 2.77v15.52zm2.787-18.289h3.97v9.109h-3.97zm6.756-.001h4.025v18.29h-4.025zm6.812 0h4.025v18.29h-4.025zm19.397 18.29h-4.006v-14.382h-8.58v-3.908h9.44c.866 0 1.607.27 2.223.808.615.538.924 1.284.924 2.238v15.244z",
  fill: "#003a70"
}), /*#__PURE__*/React.createElement("path", {
  d: "m83.814 21.116h7.868v2.795h-7.868z",
  fill: "#ff4438"
}));
var SvgLogoLean = function SvgLogoLean(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 92 24",
    width: 92,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoLean, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoLean.a5c072e7.svg";
export { ForwardRef as ReactComponent };